import { Grid, Tooltip} from "@mui/material";

export function getInventoryStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'businessid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        productid:{
            name:'productid',
            label:'Product Id',
            value:'',
            error:false,
            errorMessage:'You must enter Product Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        productname:{
            name:'productname',
            label:'Product Name',
            value:'',
            error:false,
            errorMessage:'You must enter Product Name',
            required:true,
            fieldtype:'string'
        },
        itemcount:{
            name:'itemcount',
            label:'Item Count',
            value:'',
            error:false,
            errorMessage:'You must enter Item Count',
            required:true,
            fieldtype:'number'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        productorderid:{
            name:'productorderid',
            label:'Product Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        credititemid:{
            name:'credititemid',
            label:'Credit Item Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'productid', headerName: 'Product Id', width:150 },
        { field: 'productname', headerName: 'Product Name', width:150 },
        { field: 'itemcount', headerName: 'Item Count', width:150 },
        { field: 'orderid', headerName: 'Order Id', width:150 },
        { field: 'productorderid', headerName: 'Product Order Id', width:150 },
        { field: 'credititemid', headerName: 'Credit Item Id', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['productname']:{
          ...formValues['productname'],
          value:data.productname,
        },['itemcount']:{
          ...formValues['itemcount'],
          value:data.itemcount,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['productorderid']:{
          ...formValues['productorderid'],
          value:data.productorderid,
        },['credititemid']:{
          ...formValues['credititemid'],
          value:data.credititemid,
        },
      })
}